import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';

import s from '../Register/Step/StepFour/StepFour.module.css';
import { TextField } from '../TextField';

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiFilledInput-root': {
            backgroundColor: '#F7F7F7',
            paddingBlock: '24px',
        },
        '& .MuiFilledInput-root .Mui-error': {
            backgroundColor: '#F7F7F7',
        },
        '& .MuiFormLabel-root': {
            color: '#8692A6',
        },
        marginBottom: '0 !important',
        error: {
            border: '1px solid #F90000',
        },
    },

    paper: {
        width: '100%',
        marginLeft: -1,
        boxShadow: '0px 5px 20px rgba(31, 50, 61, 0.19) !important',
    },
    option: {
        '&:hover': {
            backgroundColor: '#F2F6F7',
            marginBottom: 0,
        },
        '&[aria-selected="true"]': {
            color: '#1094F7',
            borderLeft: '2px solid #1094F7',
            backgroundColor: 'transparent',
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: 14,
            minHeight: 35,
            padding: '10px 12px',
            lineHeight: '15.4px',
        },
    },
}));

const RenderInput = (props) => (
    <TextField label={i18next.t('CityInput.return.RenderInput.label')} {...props} />
);

const LISTBOX_ID = 'city-options-listbox';

export const CityInput = ({ updateCity, cityList, setErrors, errors }) => {
    const styles = useStyles();

    const writeError = (e) => {
        if (!e.target.value) {
            setErrors((prevState) => ({
                ...prevState,
                city: i18next.t('CityInput.return.writeError.cityField'),
            }));
        } else {
            setErrors((prevState) => ({ ...prevState, city: null }));
        }
    };

    return (
        <div className={s.autocompleteWrapper}>
            <Autocomplete
                classes={styles}
                popupIcon={false}
                options={cityList}
                openOnFocus
                ListboxProps={{
                    id: LISTBOX_ID,
                    'data-id': 'city-options-list',
                }}
                data-id="city-input"
                noOptionsText={i18next.t('CityInput.return.Autocomplete.noOptionsText')}
                onChange={(e, value, reason) => {
                    if (reason === 'select-option') {
                        setErrors((prevState) => ({ ...prevState, city: null }));
                    }
                    if (reason === 'clear') {
                        updateCity(null);
                    } else {
                        updateCity(value.id);
                    }
                }}
                onBlur={writeError}
                getOptionLabel={(option) => `${option.name}, ${option.region.name}`}
                renderInput={(params) => (
                    <RenderInput
                        {...params}
                        error={!!errors.city}
                        helperText={errors.city ?? ' '}
                        margin="dense"
                    />
                )}
            />
        </div>
    );
};
